import React from 'react';
import ReactMarkdown from 'react-markdown';
import { humanizeSnakeCaseText } from './formatters';

function visitTextNodes(node) {
    if (!node || node.type === 'code' || node.type === 'inlineCode') return;

    if (node.type === 'text') {
        node.value = humanizeSnakeCaseText(node.value);
        return;
    }

    if (Array.isArray(node.children)) {
        node.children.forEach(visitTextNodes);
    }
}

function remarkHumanizeSnakeCase() {
    return tree => visitTextNodes(tree);
}

const MARKDOWN_PLUGINS = [remarkHumanizeSnakeCase];

const MARKDOWN_COMPONENTS = {
    a: ({ href, children }) => {
        const safeHref = typeof href === 'string'
            && /^(https?:\/\/|\/|#)/i.test(href)
            ? href
            : null;

        if (!safeHref) return <span>{children}</span>;

        return (
            <a href={safeHref} target="_blank" rel="noopener noreferrer">
                {children}
            </a>
        );
    },
};

const MarkdownContent = ({ content, className = '' }) => (
    <div className={className}>
        <ReactMarkdown
            skipHtml
            remarkPlugins={MARKDOWN_PLUGINS}
            components={MARKDOWN_COMPONENTS}
        >
            {String(content || '')}
        </ReactMarkdown>
    </div>
);

export default MarkdownContent;

